import { Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';

@Component({
  selector: 'app-input-decimal-react',
  templateUrl: './input-decimal-react.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDecimalReactComponent),
      multi: true
    }
  ]
})

export class InputDecimalReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

  protected numericSpan?: string = undefined;
  @Input() step = 1.0;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.loadValidators();
    this.setAndUpdateValidators();
  }

  // chama método ngOnChanges da classe base e efetua o recarregamento de validadores.
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(): void {
    super.ngOnChanges();
    this.loadValidators();
    this.setAndUpdateValidators();
  }

  private loadValidators(): void {

  }
}
